import React from "react";
import LearningHubsNewContent from "../FunctionalComponents/LearningHubsNew/LearningHubsNewContent";

function LearningHubsNew() {
  return (
    <>
      <LearningHubsNewContent />
    </>
  );
}

export default LearningHubsNew;
